import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBFooter,
} from "mdbreact";
import { toast, ToastContainer } from "react-toastify";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlassArrowRight,
  faMoneyBill,
  faPrint,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import AddEditPayment from "../Payments/AddEditPayment";
import PrintPayment from "./PrintPayment";

const Payment = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(1);
  const [showPreloader, setPreloader] = useState("normal");

  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = (transtype) => {
    setRows([]);

    showAddEdit(!modalAddEdit);

    loadData();
  };

  const toastId = React.useRef(null);

  const notify = (message) => {
    toastId.current = toast.info(message);
  };

  const [bRefresh, setRefresh] = useState(false);

  const refreshGrid = (message) => {
    setRows([]);
    setRefresh(!bRefresh);

    loadData();
    notify(message);
  };

  const showResult = (message) => {
    setRefresh(!bRefresh);

    setRows([]);

    // loadData();

    loadData();

    toast.info(message, {
      closeButton: false,
    });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(
      props.apiServer + "/paymentslist?parentcode=" + props.parentcode,
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setRowCount(1);
        setRowCount(res.data.length);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const useMountEffect = (functionName) => useEffect(functionName, []);

  //   useMountEffect(checkAdminAccess);
  useMountEffect(loadData);

  //   if (isAdmin == 0) {
  //     return (
  //       <React.Fragment>
  //         <AccessDenied />
  //       </React.Fragment>
  //     );
  //   }

  const [totalPayment, settotalPayment] = useState(0);
  useEffect(() => {
    let tmpTotal = 0;
    let finalTotal = 0;
    rows.map((x) => {
      // console.log(x.sellingprice);
      tmpTotal = x.amount;
      finalTotal = finalTotal + tmpTotal;
      // console.log(finalTotal);
      settotalPayment(finalTotal);
    });
  }, [rows]);

  const TitleBar = () => {
    return (
      <>
        {" "}
        {/* <span className="text-right brown-text">
          Total Estimated Cost: <br />
          <b>
            <span className="font-weight-bold lead">P {totalPayment}</span>
          </b>
        </span> */}
      </>
    );
  };

  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  function generateString(length) {
    let result = " ";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  const id = generateString(15);
  const ds = generateString(8);

  return (
    <React.Fragment>
      <MDBCard>
        <MDBCardHeader>
          <MDBRow>
            <MDBCol md="8">
              <span
                className="h5-responsive blue-text"
                style={{
                  fontFamily: "Montserrat",
                  fontWeight: "400",
                }}
              >
                <span className="blue-text">
                  <FontAwesomeIcon icon={faMoneyBill} />
                </span>
                &nbsp; Payments
              </span>
              <span hidden>{props.parentcode}</span>
            </MDBCol>
            <MDBCol md="4" className="text-right">
              <a onClick={toggleAddEdit}>
                {" "}
                <MDBIcon
                  icon="plus"
                  size="2x"
                  className="blue-text"
                  title="Add New Payment"
                />
              </a>
              &nbsp;&nbsp; &nbsp;
              <a
                href={
                  props.apiServerHybrid +
                  "MPrint/ORPrint?reporttype=payment&code=" +
                  props.parentcode +
                  "&uc=" +
                  sessionStorage.getItem("msal.uc") +
                  "&preview=" +
                  id
                }
                target="_blank"
                className="blue-text font-weight-bold"
                title="Print All Payments"
              >
                <FontAwesomeIcon icon={faPrint} size="2x">
                  {" "}
                </FontAwesomeIcon>
              </a>
            </MDBCol>
          </MDBRow>
        </MDBCardHeader>

        <MDBRow>
          <MDBCol md="12">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={process.env.PUBLIC_URL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <React.Fragment>
                <>
                  <MaterialTable
                    title={<TitleBar></TitleBar>}
                    columns={[
                      { title: "", field: "code", hidden: true },
                      // { title: "", field: "outsourced" },
                      { title: "Date Encoded", field: "datecreated" },
                      {
                        title: "Payment Description",
                        field: "description",
                      },

                      { title: "Amount", field: "amount" },
                    ]}
                    data={rows}
                    options={{
                      search: true,
                      actionsColumnIndex: -1,

                      pageSizeOptions: [10, 25, 50, 75, 100],
                      pageSize: 10,
                      detailPanelType: "single",
                    }}
                    detailPanel={[
                      {
                        icon: () => (
                          <MDBIcon icon="list" className="blue-text" />
                        ),
                        openIcon: () => (
                          <MDBIcon
                            icon="chevron-circle-down"
                            className="red-text"
                          />
                        ),
                        tooltip: "Payment Details",
                        render: (rowData) => {
                          return (
                            <MDBContainer className="ml-0" fluid>
                              <MDBCardBody>
                                <AddEditPayment
                                  deployURL={props.deployURL}
                                  apiServer={props.apiServer}
                                  code={rowData.code}
                                  parentcode={props.parentcode}
                                  apiServerHybrid={props.apiServerHybrid}
                                  apiServerPOS={props.apiServerPOS}
                                  toggleModal={toggleAddEdit}
                                  refreshGrid={refreshGrid}
                                  refreshSales={props.refreshSales}
                                ></AddEditPayment>
                              </MDBCardBody>
                              <MDBCardFooter></MDBCardFooter>
                            </MDBContainer>
                          );
                        },
                      },
                      {
                        icon: () => (
                          <FontAwesomeIcon
                            icon={faPrint}
                            className="blue-text"
                          />
                        ),
                        openIcon: () => (
                          <MDBIcon
                            icon="chevron-circle-down"
                            className="red-text"
                          />
                        ),
                        tooltip: "Payment Details",
                        render: (rowData) => {
                          return (
                            <PrintPayment
                              deployURL={props.deployURL}
                              apiServer={props.apiServer}
                              code={rowData.code}
                              parentcode={props.parentcode}
                              apiServerHybrid={props.apiServerHybrid}
                              apiServerPOS={props.apiServerPOS}
                              toggleModal={toggleAddEdit}
                              refreshGrid={refreshGrid}
                            ></PrintPayment>
                          );
                        },
                      },
                    ]}
                  />
                </>
                <MDBCardFooter className="cloudy-knoxville-gradient">
                  <>
                    <MDBRow>
                      <MDBCol md="8"></MDBCol>
                      <MDBCol md="4" className="text-right">
                        {" "}
                        <span className="blue-text font-weight-bold pr-0 mr-0">
                          Total Payments: <br />
                        </span>
                        <span className="black-text pr-0 mr-0">
                          <b>
                            <span className="font-weight-bold lead">
                              P {totalPayment}
                            </span>
                          </b>
                        </span>
                      </MDBCol>
                    </MDBRow>{" "}
                  </>
                </MDBCardFooter>
              </React.Fragment>
            )}
          </MDBCol>
        </MDBRow>
      </MDBCard>

      <MDBModal
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <b>Add New Recommendation</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditPayment
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              code="new"
              parentcode={props.parentcode}
              apiServerHybrid={props.apiServerHybrid}
              apiServerPOS={props.apiServerPOS}
              toggleModal={toggleAddEdit}
              refreshGrid={refreshGrid}
              refreshSales={props.refreshSales}
            ></AddEditPayment>
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>

      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={2000}
      />
      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default Payment;
